// B10 S17 · the Action Center's words (CR-092; plan D11, D17). Each quotes the vendored glossary or design-system
// excerpt verbatim; D0's word suites discover this file (a lane's labels.ts) and prove the quote, the text, the status
// and the forbidden list. Words D0 already carries are imported, not repeated: the page name, the two tabs, the nine
// kinds, the four tier headings, the breach pill word, *Approvals* and the empty line.
//
// Plan D17 lists *Priority* as pending (DCR-B10-1): DC-45 names it in the design column, not in a his-words cell, so
// it is asked (`ASKED`, routed to Q-E15) and drawn pending in DC-45's sense until the vendored list carries it.

import {
  METRIC_LABELS, NAV_ITEM_LABELS, SLA_PILL_LABELS, SLA_TIER_LABELS, defineLabels, type ActionKind,
} from "@/mc";
import type { ActionSort, ActionTier, DueWindow } from "./api";

const DC45 = "Priority is the SLA tier; groups *Breach — dashboard risk · Near-breach · Reminder · Due*; sort *Priority · Due · Requisition*; kind chips in his nine words.";
const DUE_DATE = "\"Recruiter submits qualified slate in app; HM receives action-center task and due date.\"";
const BLOCKED = "5 of 9: \"Blocked — Coverage or data gap — Gap resolved\".";

export const AC_LABELS = defineLabels({
  /** The sort control (DC-45) and the name of a tier filter chip ("Priority is the SLA tier"). */
  priority: { text: "Priority" },
  sortDue: { text: "Due" },
  requisition: { text: "Requisition" },
  /** The due filter's chip name. */
  dueDate: { text: "Due date" },
  /** B1's fifth tier (`TIER_WORD["blocked"]`), its group after *Due*. */
  blocked: { text: "Blocked" },
});

/** The page's names: *Action Center*, or *Approvals* when it shows the approvals kind alone (DC-214). */
export const PAGE_WORDS = {
  actionCenter: METRIC_LABELS.actionCenter,
  approvals: NAV_ITEM_LABELS.approvals,
  prioritizedActions: METRIC_LABELS.prioritizedActions,
  history: METRIC_LABELS.history,
} as const;

/** The group headings (DC-45, the section-title words), most severe first. */
export const TIER_HEADING: Readonly<Record<ActionTier, string>> = {
  breach: SLA_TIER_LABELS.breach,
  near_breach: SLA_TIER_LABELS.nearBreach,
  reminder: SLA_TIER_LABELS.reminder,
  due: SLA_TIER_LABELS.due,
  blocked: AC_LABELS.blocked,
};

/** CR-092 (G §2): his nine kinds, the sentence D0's kind labels quote. */
const KINDS = "Prioritized actions across reqs, candidates, scheduling, packets, scorecards, panels, approvals, offers and closeout.";

/** The kind chips: his nine words (G §2), each a chip's name, so its first letter is capitalised as a control's is. */
export const KIND_WORD = defineLabels({
  reqs: { text: "Reqs" },
  candidates: { text: "Candidates" },
  scheduling: { text: "Scheduling" },
  packets: { text: "Packets" },
  scorecards: { text: "Scorecards" },
  panels: { text: "Panels" },
  approvals: { text: "Approvals" },
  offers: { text: "Offers" },
  closeout: { text: "Closeout" },
}) satisfies Readonly<Record<ActionKind, string>>;

export const SORT_WORD: Readonly<Record<ActionSort, string>> = {
  priority: AC_LABELS.priority,
  due: AC_LABELS.sortDue,
  requisition: AC_LABELS.requisition,
};

/**
 * The due windows the screen offers, each with his word. B1 also takes the end of today and the next seven days; no
 * glossary or design-system line names them and D0's suite admits no new pending word, so they wait for his words
 * (DCR-B10-1). The query parser drops a window with no word, so no filter is ever applied without a visible chip.
 */
export const DUE_WORD: Readonly<Partial<Record<DueWindow, string>>> = {
  overdue: SLA_PILL_LABELS.overdue,
};
